'use strict';

angular.module('cgmemApp')
  .controller('HelpCtrl', function ($scope) {
    $scope.message = 'Hello';
  });
